// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UQ1p","footer":"styles_footer__1248c"};